import template from './devChangeEmployee.html';
import controller from './devChangeEmployee.controller';
import './devChangeEmployee.scss';

let devChangeEmployeeComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default devChangeEmployeeComponent;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/index/devChangeEmployee/devChangeEmployee.component.js